module.exports = __webpack_public_path__ + "assets/img/2820467f-3219-4716-bf47-20f26fdba3d7.e9e13f47.png";